import { QFilterGeneric } from "./QFilterGeneric";
import { get_qfilter } from "./index";

export class QFilters { // Ex ExplorerFilters
  constructor(qfilters) {
    this._filters = {};
    this._tmp = [];
    this._delete = [];

    if (qfilters) { 
      if (qfilters instanceof QFilters) {
        this._filters = {...qfilters._filters};
        this._tmp = qfilters._tmp;
        this._delete = qfilters._delete;
      } else {
        for (const [key,filter] of Object.entries(qfilters)) {
          if (filter instanceof QFilterGeneric) {
            this._filters[key] = filter;
          } else {
            this._filters[key] = get_qfilter(key,filter);
          }
        }
      }
    }
  }

  set_filter(fil, tmp=false) {
    this.clear_tmp()
    
    if (fil instanceof QFilterGeneric) {
      this._filters[fil.name] = fil
      if (tmp) {
        this._tmp.push(fil.name);
      }
    }
  }

  unset_filter(name) {
    if (this._filters[name]) {
      delete this._filters[name]
    }
  }

  delete_filter(name) {
    if (!this._delete.includes(name)) {
      this._delete.push(name);
    }
  }

  get_filter(name) {
    if (name && this._filters[name]) {
      return this._filters[name];
    }
  }

  get_filter_value(name) {
    let filter = this.get_filter(name);
    if (filter && filter instanceof QFilterGeneric) {
      return filter.value;
    }
  }

  merge(target) {
        let qf = new QFilters(this);
    this.clear_tmp();
    if (target instanceof QFilters) {
      qf._delete = target._delete;
      qf.clear_delete();
      for (const f of Object.values(target._filters)){
        qf.set_filter(f);
      }
      qf._tmp = target._tmp;
    }
    return qf;
  }

  clear_tmp() {
    if (this._tmp.length > 0) {
      for (const filter of this._tmp) {
        this.unset_filter(filter);
      }
      this._tmp = [];
    }
  }

  clear_delete() {
    if (this._delete.length > 0) {
      for (const filter of this._delete) {
        this.unset_filter(filter);
      }
    }
    this._delete = [];
  }

  keys() {
    return Object.keys(this._filters);
  }

  copy(items) {
    if (items) {
      let res = {};
      for (const filter of items) {
        const filt = this.get_filter(filter)
        if (filt) {
          res[filter] = filt;
        }
      }
      return new QFilters(res);
    }
    return new QFilters(this)
  }

  as_query() {
    let res = {};
    
    let values = Object.values(this._filters)
    
    for (const fil of values) {
      if (fil && fil.validate()) {
        res = {...res, ...fil.as_query(this)};
      }
    }
    return res;
  }
}
